export default {
  sm: `
  데이터는 교육, 의료, 금융, 공공 등 여러 산업
  분야에서 활용되며 새로운 가치를 창출하고 있습니다.
  20세기 초 산업 현장을 가동한 원유의 역할을
  이제는 데이터가 대신합니다.
  `,
  lg: `
  데이터는 교육, 의료, 금융, 공공 등 여러 산업 분야에서 활용되며
  새로운 가치를 창출하고 있습니다. 20세기 초 산업 현장을 가동한
  원유의 역할을 이제는 데이터가 대신합니다.
  `
};
